module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_RaggedRight",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.17em"
    }
  }, [_vm._v("“I want to prove that ghosts exist, and you guys had an opening in my area of expertise just as I graduated. Kind of seems like fate.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("“What’s your area?” Blaine liked Flynn’s attitude already, though. He wasn’t going into it predisposed to disbelief. He wanted to prove ghosts existed, like Blaine.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("“Electromagnetism, biology, and computers. I’ve written a few programs to crunch the data for temperature changes, etc. And they can totally be tweaked as needed. Plus… well, I guess you guys are the ones for whom this is a pro not a con, but I’ve experienced ghosts before.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("“Yeah? When?” That wasn’t particularly unique. Ghosts were everywhere, and people also got spooked by things that "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("weren’t")]), _vm._v(" ghosts all the time.")]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_vm._v("“Most of my life, actually.” Flynn held his gaze for a long moment, and Blaine felt like the guy was testing him. He must have passed because Flynn continued. “My parents died when I was five. Car accident. Every now and then, when I really need her, my mother comes to me.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0